import React, { useEffect, useMemo, useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from './Sidebar';
import { useLocation } from 'react-router-dom';
import { PageProps } from '../types';

interface ManageFixedAssetsLayoutProps {
  children: React.ReactNode;
  pages: PageProps[];
}

const ManageFixedAssetsLayout: React.FC<ManageFixedAssetsLayoutProps> = ({ children, pages }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isMobile);
  const [activePageTitle, setActivePageTitle] = useState('Managed Fixed Assets');
  const location = useLocation();

  useEffect(() => {
    setIsSidebarOpen(!isMobile);
  }, [isMobile]);

  useEffect(() => {
    const segments = location.pathname.split('/').filter(Boolean);
    const activePage = pages.find(page =>
      segments.length > 0 &&
      page.path.replace('/*', '').split('/').filter(Boolean)[0] === segments[0]
    );
    if (activePage) {
      setActivePageTitle(activePage.title);
    }
  }, [location.pathname, pages]);

  const pagePropsList = useMemo<PageProps[]>(() => pages.map((page) => ({
    title: page.title,
    icon: page.icon || null,
    tabs: page.tabs,
    path: page.path,
    show: page.show,
    element: page.element,
  })), [pages]);

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden', bgcolor: '#F9FAFB' }}>
      <Sidebar
        isOpen={isSidebarOpen}
        onToggle={() => setIsSidebarOpen(prev => !prev)}
        activePageTitle={activePageTitle}
        onPageChange={setActivePageTitle}
        pagePropsList={pagePropsList}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          marginLeft: isSidebarOpen ? '310px' : '64px',
          height: '100vh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          '@media (max-width: 600px)': {
            marginLeft: isSidebarOpen ? '0' : '64px',
            width: '100%',
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default ManageFixedAssetsLayout;
